import { Property } from '../property'

/**
 * TODO: remove inheritance
 */
export class PropertySpec {
  public propertyId: string
  public property: Property
  public inputRequired: boolean
  public singleSelection: boolean
}
